import { props, createAction } from '@ngrx/store'
import { Visitor, VisitorsResponse } from '../../models/visitor.model'
import { Paging } from 'src/app/models/page.model'
import { Update } from '@ngrx/entity'

export const ContactsRequested = createAction(
    '[Contacts] Contacts Requested',
    props<{paging: Paging}>(),
)

export const ContactsRequestSuccess = createAction(
    '[Contacts] Contacts Loaded',
    props<{visitors: VisitorsResponse}>(),
)

export const ContactsUpdate = createAction(
    '[Contacts] Visitor Update New or Existing',
    props<{visitor: Visitor}>(),
)

export const ContactsPropertySelected = createAction(
    '[Contacts] Property Selected',
    props<{property_id: number}>(),
)

export const ContactsExport = createAction(
    '[Contacts] Export Request',
    props<{file_type: string}>(),
)

export const SingleContactRequest = createAction(
    '[Contacts] Single Contact Request From EditContact Component',
    props<{contact_id: string}>(),
)

export const SingleContactRequestSuccess = createAction(
    '[Contacts] Single Contact Request Success From EditContact Component',
    props<{contact: Update<Visitor>}>(),
)

export const ContactSaveRequest = createAction(
    '[Contacts] Save Contact Details Request',
    props<{contact: Update<Visitor>}>(),
)

export const ContactSaveSuccess = createAction(
    '[Contacts] Save Contact Details Success',
    props<{contact: Update<Visitor>}>(),
)

export const ContactDeleteRequest = createAction(
    '[Contacts] Delete Contact Request',
    props<{contact_id: string}>(),
)

export const ContactDeleteSuccess = createAction(
    '[Contacts] Delete Contact Success',
    props<{contact_id: string}>(),
)

export const ContactDeleteFailed = createAction(
    '[Contacts] Delete Contact Failed',
    props<{message: string}>(),
)
